import { jsx as _jsx } from "react/jsx-runtime";
import { FieldText } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import * as React from 'react';
export class RSFieldText extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }
    onChange(e) {
        if (!e)
            return;
        const { name, onChange } = this.props;
        const { value } = e.target;
        if (typeof value === 'string') {
            onChange(e, name, value);
        }
    }
    render() {
        const { name, value } = this.props;
        return (_jsx(FieldText, { placeholder: "Enter a value", input: { name, value, onChange: this.onChange } }));
    }
}
